var exports = {
  "_A": "xaf9ae18d--35a841--tags",
  "Tc": "xaf9ae18d--35a841--tag",
  "W0": "xaf9ae18d--35a841--tag-rate",
  "xx": "xaf9ae18d--35a841--tag--orange",
  "W2": "xaf9ae18d--35a841--tag--red",
  "d4": "xaf9ae18d--35a841--star",
  "hc": "xaf9ae18d--35a841--tag-text",
};

module.exports = exports;
